<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 9.5h-2V7A5 5 0 007 7v2.5H5a1 1 0 00-1 1V21a1 1 0 001 1h14a1 1 0 001-1V10.5a1 1 0 00-1-1zM9 7a3 3 0 016 0v2.5H9zm9 13H6v-8.5h12z"/><path d="M14.15 13.52l-2.84 2.79L9.83 15a.5.5 0 10-.66.74L11 17.37a.5.5 0 00.34.13.54.54 0 00.35-.14l3.17-3.13a.5.5 0 10-.7-.71z"/></svg>